import { ThemeProvider } from '@mui/material/styles';
import { gsTheme } from './themes/app-theme';
import React from 'react';
import './themes/app-style.scss'; // last to override other styling

const StylerHOC = <T extends {}>(
  WrappedComponent: React.FC<T>
): React.FC<T> => {
  return (props: T): JSX.Element => {
    return (
      <ThemeProvider theme={gsTheme}>
        <WrappedComponent {...(props as any)} />
      </ThemeProvider>
    );
  };
};

export default StylerHOC; // Naming it Styler because it add Theme and our special style/css
